const initState = {
  isRequesting: false,
  error: null,
}

export default initState
